import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'nio-account-managers-modal',
    templateUrl: './account-managers-modal.component.html',
    styleUrls: ['./account-managers-modal.component.scss'],
    standalone: false
})
export class AccountManagersModalComponent {
  constructor(
    public dialogRef: MatDialogRef<AccountManagersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
